<div class="mt-8">

    <div class="w-full row-span-full flex justify-start mb-4">
        <button [routerLink]="['..']"
            class="text-primary-500 hover:bg-primary-100 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"><i class="fa fa-chevron-left mr-2 leading-relaxed"></i>
            Back
        </button>
    </div>

    <div class="flex flex-col break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">

        <div class="rounded-t-lg bg-white">
            <div class="rounded-t bg-white mb-0 px-6 py-4">
                <span class="text-blueGray-700 text-lg font-bold">New Channel</span>
            </div>
        </div>

        <mat-stepper orientation="vertical" linear="true" #stepper class="bg-blueGray-100 rounded-b-lg">

            <mat-step [stepControl]="channelNameFormGroup" label="Channel Availability">

                <form [formGroup]="channelNameFormGroup">
                    <div class="pt-4">

                        <div class="w-full mb-1">
                            <p class="text-sm text-primary-300 mb-1">Select a unique name for your Channel.</p>
                            <p class="text-sm text-primary-300 mb-4">Refer
                                <span (click)="namingDialog()"
                                    class="text-secondary-500 underline cursor-pointer">Channel Naming
                                    Guidelines</span>, for
                                recommendations and
                                restrictions.
                            </p>
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Channel Name
                            </label>
                            <input type="text" type="name" formControlName="name" id="name" name="name" required
                                class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full py-1.5 px-3 ease-linear transition-all duration-150" />
                            <div
                                class="{{ channelNameFormGroup.get('name')?.invalid && (channelNameFormGroup.get('name')?.dirty || channelNameFormGroup.get('name')?.touched) ? 'visible' : 'invisible'}} pt-1 h-6 text-red-500 text-xs">
                                <p *ngIf="channelNameFormGroup.get('name')?.errors?.['required']">
                                    Value is required
                                </p>
                                <p
                                    *ngIf="channelNameFormGroup.get('name')?.errors?.['minlength'] || channelNameFormGroup.get('name')?.errors?.['maxlength']">
                                    Min 10 and max 200 characters required
                                </p>
                                <p *ngIf="channelNameFormGroup.get('name')?.errors?.['nameTaken']">
                                    Channel Name Unavailable or Not Allowed
                                </p>
                                <p *ngIf="channelNameFormGroup.get('name')?.errors?.['failed']">
                                    {{ channelNameFormGroup.get('name')?.errors?.['failed'].message}}
                                </p>
                            </div>
                        </div>
                        <div>
                            <button type="button"
                                [disabled]="checkingAvailability || channelNameFormGroup.get('name')?.errors"
                                (click)="checkAvailability()"
                                class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 mt-2 mr-2 text-white font-bold text-sm uppercase rounded px-4 py-2"
                                mat-button>
                                <div *ngIf="!checkingAvailability && !((working$ | async) ?? false)"
                                    class="inline-block">
                                    <i class="far fa-check-circle mr-2 leading-relaxed"></i>Check Availability
                                </div>
                                <div *ngIf="checkingAvailability || (working$ | async)" class="inline-block">
                                    <app-loading-dots></app-loading-dots>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>

            </mat-step>

            <mat-step label="Register Channel" [stepControl]="acceptTermsFormGroup">

                <form [formGroup]="acceptTermsFormGroup">
                    <div class="pt-4">

                        <div class="w-full mb-1">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Channel Name
                            </label>
                            <span
                                class="text-green-700 capitalize font-semibold text-sm">{{channelNameFormGroup.get('name')?.value}}</span>
                        </div>
                        <div class="w-full mt-4 mb-1">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Description
                            </label>
                            <textarea type="text" type="description" formControlName="description" id="description"
                                name="description" required
                                class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                rows="4">
                            </textarea>
                            <div
                                class="{{ acceptTermsFormGroup.get('description')?.invalid && (acceptTermsFormGroup.get('description')?.dirty || acceptTermsFormGroup.get('description')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                                <p *ngIf="acceptTermsFormGroup.get('description')?.errors?.['required']">
                                    Value is required
                                </p>
                                <p
                                    *ngIf="acceptTermsFormGroup.get('description')?.errors?.['minlength'] || acceptTermsFormGroup.get('description')?.errors?.['maxlength']">
                                    Min 10 and max 500 characters required
                                </p>
                            </div>
                        </div>
                        <div class="w-full mt-4 mb-1">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold">
                                Tags
                            </label>
                            <div class="flex flex-wrap gap-1">
                                <button (click)="removeTag(i)" type="button" *ngFor="let item of tags; index as i"
                                    data-dismissible="chip"
                                    class="relative flex select-none items-center whitespace-nowrap rounded-lg bg-primary-500 py-1.5 px-3 my-1 text-xs font-bold text-white">
                                    <span class="grow-0">{{item}}<i class="fa fa-close ml-2 leading-relaxed"></i></span>
                                </button>
                            </div>
                            <div class="flex flex-row align-middle mt-2">
                                <input formControlName="tagField" id="tagField" name="tagField" type="text"
                                    class="border-0 grow placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                <button (click)="addTag()" type="button"
                                    class="bg-primary-500 basis-1/4 whitespace-nowrap rounded ml-4 text-xs text-white px-2">Add
                                    Tag</button>
                            </div>
                            <div
                                class="{{acceptTermsFormGroup.get('tagField')?.invalid && (acceptTermsFormGroup.get('tagField')?.dirty || acceptTermsFormGroup.get('tagField')?.touched)? 'visible' : 'invisible' }} pt-1 h-4 text-red-500 text-xs">
                                @if(acceptTermsFormGroup.get('tagField')?.errors?.['invalidValue']) {
                                <p>No blanks or spaces allowed</p>
                                } @else if(acceptTermsFormGroup.get('tagField')?.errors?.['maxValuesAllowed']) {
                                <p>Only 10 values allowed</p>
                                }
                            </div>
                        </div>
                        <div class="w-full mt-4 mb-1">
                            <input formControlName="acceptTerms" name="acceptTerms" id="acceptTerms" type="checkbox"
                                class="ml-1 w-4 h-4 text-secondary-500 rounded focus:outline-none focus:ring-0">
                            <label class="ms-2 text-sm font-normal">
                                Accept <span (click)="channelTnCs()"
                                    class="text-secondary-500 underline cursor-pointer">
                                    Terms & Conditions</span>
                            </label>
                        </div>
                        <div class="flex flex-row gap-4 justify-start mt-8">
                            <app-btn-action type="button" label="Back" [isDisabled]="(working$ | async) ?? false"
                                bgColor="bg-transparent hover:bg-primary-100 active:bg-primary-100"
                                textColor="text-primary-500" icon="fa fa-chevron-left"
                                (click)="goToCheckAvailability()"></app-btn-action>
                            <button type="button" (click)="createChannel()"
                                [disabled]="(working$ | async) || channelNameFormGroup.get('name')?.errors || acceptTermsFormGroup.invalid || !channelNameFormGroup.get('isUnique')?.value"
                                class="bg-secondary-500 hover:bg-secondary-700 active:bg-primary-500 disabled:bg-primary-200 text-white focus:outline-none font-bold text-sm uppercase rounded px-4 py-2"
                                mat-button>
                                <div *ngIf="!((working$ | async) ?? false)" class="inline-block">
                                    <i class="far fa-check-circle mr-2 leading-relaxed"></i>Create Channel
                                </div>
                                <div *ngIf="(working$ | async) ?? false" class="inline-block">
                                    <app-loading-dots></app-loading-dots>
                                </div>
                            </button>
                        </div>
                    </div>
                </form>

            </mat-step>

        </mat-stepper>

    </div>

</div>